/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Modal popup to remove table row
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.3.0
 */

import { useDispatch, useSelector } from 'react-redux';

import { makeSelectTranslationCommon } from '../../../../../modules/internationalization/intSelectors';
import Modal from '../../../../../modules/modal/components/Modal';
import ButtonServiceUserDenied from '../../../../../modules/role/components/ButtonServiceUserDenied';
import { LinkBlock } from '../../../../common';
import { tableRemoveRowAction } from '../../../actions/tableActions';


interface ITableRemoveRowModalPopupProps {
    message: string;
    onCloseModal: () => void;
    rowId: number;
}

type TTableRemoveRowModalPopup = ITableRemoveRowModalPopupProps;

const TableRemoveRowModalPopup = (props: TTableRemoveRowModalPopup) => {

    const dispatch = useDispatch();

    const { modal } = useSelector(makeSelectTranslationCommon());

    const handleRemoveButtonClick = () => {
        dispatch(tableRemoveRowAction({ rowId: props.rowId }));
        props.onCloseModal();
    };
    return (
        <Modal
            dataName={'table-remove-row-modal-popup'}
            width="400px"
        >
            <Modal.Title dataName="modal-popup-title">
                {modal.attention}
            </Modal.Title>

            <Modal.Text data-name="modal-popup-text">
                {props.message}
            </Modal.Text>
            <Modal.Control>
                <ButtonServiceUserDenied
                    dataName="remove-button"
                    kind="medium"
                    onClick={handleRemoveButtonClick}
                >
                    {modal.remove}
                </ButtonServiceUserDenied>
                <LinkBlock
                    className="basket__footer-link"
                    dataName="close-button"
                    onClick={props.onCloseModal}
                >
                    {modal.close}
                </LinkBlock>
            </Modal.Control>
        </Modal>
    );
};

export default TableRemoveRowModalPopup;
